(function () {
    'use strict';
    var controllerId = 'accred7';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', 'filterFilter', '_', 'commonAttach', accred7]);

    function accred7($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu, filterFilter, _, commonAttach) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');


        var vm = this;
        vm.title = 'Mis.7 Accred.';
        vm.view = 'list';       //Mettendo 'detail' si elimina l'errore del $compile: ctreq
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "accreditamento"; //Utilizzato per pannello authorization		
        vm.authorization = {};
        vm.tSourceCode_ACCR = "ACCR_7";
        vm.isVisibleLinkDomanda = false;
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.maxStep = 4;
        vm.iFinestra = 1; //PRIMA FINESTRA

        vm.index = 0;
        vm.custom = false;
        vm.showInfoMsg = true;
        vm.setShowInfoMsg = setShowInfoMsg;
        vm.ableMenu = true;
        vm.PdfReady = true;
        vm.classStep = [];
        vm.classStepIcon = [];
        vm.classStepComplete = [];
        vm.stepEdit = [];
        vm.stepCompleted = [];
        vm.myPristine = false;
        vm.isClickDay = false;

        vm.errorAccess = '';

        //Pannelli dei dati (viewAccred)
        vm.showPanelAccred1 = true;
        vm.showPanelAccred2 = true;
        vm.showPanelAccred3 = true;
        vm.showPanelAccred4 = true;
        vm.setShowPanelAccred1 = setShowPanelAccred1;
        vm.setShowPanelAccred2 = setShowPanelAccred2;
        vm.setShowPanelAccred3 = setShowPanelAccred3;
        vm.setShowPanelAccred4 = setShowPanelAccred4;

        //Pannelli dei dati (viewSede)
        vm.showPanelSede1 = true;
        vm.showPanelSede2 = true;
        vm.setShowPanelSede1 = setShowPanelSede1;
        vm.setShowPanelSede2 = setShowPanelSede2;

        //Pannelli dei dati (viewAtt)
        vm.showPanelAtt1 = true;
        vm.showPanelAtt2 = true;
        vm.showPanelAtt3 = true;
        vm.setShowPanelAtt1 = setShowPanelAtt1;
        vm.setShowPanelAtt2 = setShowPanelAtt2;
        vm.setShowPanelAtt3 = setShowPanelAtt3;

        //Pannelli dei dati (viewRiep)
        vm.showPanelRiep1 = true;
        vm.setShowPanelRiep1 = setShowPanelRiep1;

        vm.addDisabled = false;
        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;
        vm.saving = false;

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;
        vm.get = getRecord;
       

        //Filtro
        vm.filter = {};
        vm.fIStato = 0;
        vm.fTestuale = '';
        vm.fProgettoId = 0;
        vm.fMisuraCode = '7';

        vm.filter.iStato = vm.fIStato;
        vm.filter.testuale = vm.fTestuale;
        vm.filter.progettoId = vm.fProgettoId;
        vm.filter.misuraCode = vm.fMisuraCode;

        vm.cndProgetto = {};
        vm.adesione = {};
        vm.urlRoot = datacontext.accred_getURL();

        vm.testing = true;

        //Elenco per Ordinamento
        vm.list = {};
        vm.list.ordine = ['data ricevuta', 'data protocollo', 'ragione sociale'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        //Elenchi dettaglio
        vm.list.attach = [];

        vm.list.b_attach = false;

        vm.list.cndAccredSedi = [];
        vm.list.cndAccredSettori = [];



        //Attach 2
        vm.tAttach_Needed = [];
        vm.tAttach_ACCR = [];
        vm.list.attach_accr = [];

        vm.addAttach = addAttach;
        vm.disableCompleted = true;
        vm.getListAttach = getListAttach;
        vm.deleteAttach = deleteAttach;

        vm.changeStateAttach = commonAttach.changeStateAttach;
        vm.extractCADESFile = commonAttach.extractCADESFile;
        vm.extractVerifySignInfo = commonAttach.extractVerifySignInfo;
        vm.safeDownload = commonAttach.safeDownload;

        vm.populateAttach = populateAttach;

        //Conteggio Elenchi
        vm.countAttachProfilo = function () {
            var filter = {};
            return filterFilter(vm.list.attach, filter).length;
        };


        //Filtro
        vm.fAttach = {};
        vm.setfAttach = setfAttach;

        //Elenchi per filtri e finestra modale di Create
        vm.tSource = {};
        vm.tAttach = [];

        //Elenchi per <select>
        vm.cmblist = {};

        //-- Rappresentante LEGALE
        //Nascita
        vm.cmblist.L_Nasc_Paesi = [];
        vm.cmblist.L_Nasc_Province = [];
        vm.cmblist.L_Nasc_Comuni = [];
        //Cittadinanza
        vm.cmblist.L_Cittadinanze = [];

        //Residenza
        vm.cmblist.L_Res_Paesi = [];
        vm.cmblist.L_Res_Province = [];
        vm.cmblist.L_Res_Comuni = [];
        vm.cmblist.L_Res_TIndirizzi = [];

        //-- Azienda
        //Sede legale
        vm.cmblist.SL_Paesi = [];
        vm.cmblist.SL_Province = [];
        vm.cmblist.SL_Comuni = [];
        vm.cmblist.SL_TIndirizzi = [];

        //INPS
        vm.cmblist.M7_INPS_Province = [];
        vm.cmblist.M7_INPS_Comuni = [];

        //INAIL
        vm.cmblist.M7_INAIL_Province = [];
        vm.cmblist.M7_INAIL_Comuni = [];

        //CNDSettori
        vm.cmblist.cndSettori = [];

        //Gestione conferma input di tipo Email
        vm.confirm = {};

        vm.saveAccred = saveOrUpdateAccred;
        vm.delete = deleteItem;
        vm.download = downloadItem;

        vm.prevStep = prevStep;
        vm.nextStep = nextStep;

        vm.isVisiblePrevButton = isVisiblePrevButton;
        vm.isVisibleNextButton = isVisibleNextButton;
        vm.isVisibleSaveButton = isVisibleSaveButton;


        vm.isAblePrevButton = isAblePrevButton;
        vm.isAbleNextButton = isAbleNextButton;
        vm.isAbleSaveButton = isAbleSaveButton;
        vm.isAbleAddButton = isAbleAddButton;

        vm.setStep = setStep;



        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;
            if (iOpened == 1) vm.opened1 = true;
            else if (iOpened == 2) vm.opened2 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.L_DtNasc = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.adesione.DDG_Dt = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';

        // #region Localizzazione

        //-- Localizzazione Nascita Rappres. Legale (L)
        vm.change_Paese_LNasc = function () {
            if (vm.record.L_PaeseNascId > 0) {
                vm.record.L_ProvNascId = 0;
                vm.record.L_ComuneNascId = 0;
            }
        };
        vm.change_Comuni_LNasc = function (idprov) {
            vm.record.L_ComuneNascId = '';
            vm.getComuni_LNasc(idprov);
        };
        vm.getPaesi_LNasc = function () {
            if (vm.cmblist.L_Nasc_Paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.L_Nasc_Paesi = data;
            });
        };
        vm.getProvince_LNasc = function () {
            if (vm.cmblist.L_Nasc_Province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.L_Nasc_Province = data;
            });
        };
        vm.getComuni_LNasc = function (idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.L_Nasc_Comuni = [];
            }

            if (vm.record.L_ProvNascId != idprov)
                vm.cmblist.L_Nasc_Comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.L_Nasc_Comuni = data;
            });
        };
        //-- END

        //Rappresentante Legale Cittadinanze
        vm.getCittadinanze_L = function () {
            if (vm.cmblist.L_Cittadinanze.length > 0) return;

            datacontext.arrCittadinanze().then(function (data) {
                vm.cmblist.L_Cittadinanze = data;
            });
        };

        //-- Localizzazione Residenza Legale Rappr
        vm.change_Paese_LRes = function () {
            if (vm.record.L_ResPaeseId > 0) {
                vm.record.L_ResProvinciaId = 0;
                vm.record.L_ResComuneId = 0;
            }
        };
        vm.change_Comuni_LRes = function (idprov) {
            vm.record.L_ResComuneId = '';
            vm.getComuni_LRes(idprov);
        };
        vm.getPaesi_LRes = function () {
            if (vm.cmblist.L_Res_Paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.L_Res_Paesi = data;
            });
        };
        vm.getProvince_LRes = function () {
            if (vm.cmblist.L_Res_Province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.L_Res_Province = data;
            });
        };
        vm.getComuni_LRes = function (idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.L_Res_Comuni = [];
            }

            if (vm.record.L_ResProvinciaId != idprov)
                vm.cmblist.L_Res_Comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.L_Res_Comuni = data;
            });
        };
        vm.getTIndirizzi_LRes = function () {
            if (vm.cmblist.L_Res_TIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.L_Res_TIndirizzi = data;
            });
        };
        //-- END

        //-- Localizzazione Sede Legale (SL)
        vm.change_Paese_SL = function () {
            if (vm.record.SedeLeg_PaeseId > 0) {
                vm.record.SedeLeg_ProvinciaId = 0;
                vm.record.SedeLeg_ComuneId = 0;
            }
        };
        vm.change_Comuni_SL = function (idprov) {
            vm.record.SedeLeg_ComuneId = '';
            vm.getComuni_SL(idprov);
        };
        vm.getPaesi_SL = function () {
            if (vm.cmblist.SL_Paesi.length > 0) return;

            datacontext.arrPaesi().then(function (data) {
                vm.cmblist.SL_Paesi = data;
            });
        };
        vm.getProvince_SL = function () {
            if (vm.cmblist.SL_Province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.SL_Province = data;
            });
        };
        vm.getComuni_SL = function (idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.SL_Comuni = [];
            }

            if (vm.record.SedeLeg_ProvinciaId != idprov)
                vm.cmblist.SL_Comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.SL_Comuni = data;
            });
        };
        vm.getTIndirizzi_SL = function () {
            if (vm.cmblist.SL_TIndirizzi.length > 0) return;

            datacontext.arrTIndirizzo().then(function (data) {
                vm.cmblist.SL_TIndirizzi = data;
            });
        };
        //-- END

        //-- Localizzazione INPS
        vm.change_Comuni_M7_INPS = function (idprov) {
            vm.record.M7_INPS_ComuneId = '';
            vm.getComuni_M7_INPS(idprov);
        };
        vm.getProvince_M7_INPS = function () {
            if (vm.cmblist.M7_INPS_Province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.M7_INPS_Province = data;
            });
        };
        vm.getComuni_M7_INPS = function (idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.M7_INPS_Comuni = [];
            }

            if (vm.record.M7_INPS_ProvinciaId != idprov)
                vm.cmblist.M7_INPS_Comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.M7_INPS_Comuni = data;
            });
        };

        //-- Localizzazione INAIL
        vm.change_Comuni_M7_INAIL = function (idprov) {
            vm.record.M7_INAIL_ComuneId = '';
            vm.getComuni_M7_INAIL(idprov);
        };
        vm.getProvince_M7_INAIL = function () {
            if (vm.cmblist.M7_INAIL_Province.length > 0) return;

            datacontext.arrProvince().then(function (data) {
                vm.cmblist.M7_INAIL_Province = data;
            });
        };
        vm.getComuni_M7_INAIL = function (idprov) {
            if (!idprov || idprov == 0) {
                return vm.cmblist.M7_INAIL_Comuni = [];
            }

            if (vm.record.M7_INAIL_ProvinciaId != idprov)
                vm.cmblist.M7_INAIL_Comuni = [];

            return datacontext.istat_comune_getAllList(idprov).then(function (data) {
                return vm.cmblist.M7_INAIL_Comuni = data;
            });
        };

        // #endregion

        // ---- ACTIVATE -------
        loadStepParams();
        activate();

        function activate() {
            if ($routeParams.projectUID != null) {
                return getCNDProgetto($routeParams.projectUID).then(function () {
                    if ($routeParams.accreditamentoUID != null) {
                        return getRecordByUID($routeParams.accreditamentoUID).then(function () {
                            if (!vm.record.Completed) {
                                var promises = [
                                    getTSourceACCR()
                                    , getTAttach(vm.tSourceCode_ACCR)
                                    , getTAttachNeededAccr()
                                    , getCNDSettori()

                                    , vm.getPaesi_LNasc()
                                    , vm.getProvince_LNasc()
                                    , vm.getCittadinanze_L()
                                    , vm.getPaesi_LRes()
                                    , vm.getProvince_LRes()
                                    , vm.getTIndirizzi_LRes()
                                    , vm.getPaesi_SL()
                                    , vm.getProvince_SL()
                                    , vm.getTIndirizzi_SL()
                                    , vm.getProvince_M7_INPS()
                                    , vm.getProvince_M7_INAIL()
                                ];
                                return common.activateController(promises, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                            else if (!vm.record.AttachChecked) {
                                var promises1 = [
                                    getTSourceACCR(),
                                    getTAttach(vm.tSourceCode_ACCR),
                                    getTAttachNeededAccr()
                                ];
                                return common.activateController(promises1, controllerId)
                                    .then(function () {
                                        return true;
                                    });
                            }
                        });
                    }
                    else {
                        vm.record.Id = 0;
                        vm.record.TMisuraCode = '7';
                        vm.record.TRuoloCode = 'AZD_PROM-7';
                        vm.record.L_CittadinanzaId = 1;
                        vm.record.L_PaeseNascId = 0;
                        vm.record.L_ResPaeseId = 0;
                        vm.record.L_ResTIndirizzoId = 1;
                        vm.record.SedeLeg_PaeseId = 0;
                        vm.record.SedeLeg_TIndirizzoId = 1;
                        vm.record.TFormaGiuridicaId = 0;
                        vm.record.Sedi = [];
                        vm.record.M7_Settori = [];

                        var promises = [
                            getTSourceACCR()
                            , getTAttach(vm.tSourceCode_ACCR)
                            , getTAttachNeededAccr()
                            , getCNDSettori()

                            , vm.getPaesi_LNasc()
                            , vm.getProvince_LNasc()
                            , vm.getCittadinanze_L()
                            , vm.getPaesi_LRes()
                            , vm.getProvince_LRes()
                            , vm.getTIndirizzi_LRes()
                            , vm.getPaesi_SL()
                            , vm.getProvince_SL()
                            , vm.getTIndirizzi_SL()
                            , vm.getProvince_M7_INPS()
                            , vm.getProvince_M7_INAIL()
                        ];
                        return common.activateController(promises, controllerId)
                            .then(function () {
                                return setStep(0);
                            });
                    }
                });
            }
            else {
                var promises = [
                    getAuthorization()
                    , getTSourceACCR()
                    , getTAttach(vm.tSourceCode_ACCR)
                    , getTAttachNeededAccr()
                    , getCNDSettori()

                    , vm.getPaesi_LNasc()
                    , vm.getProvince_LNasc()
                    , vm.getCittadinanze_L()
                    , vm.getPaesi_LRes()
                    , vm.getProvince_LRes()
                    , vm.getTIndirizzi_LRes()
                    , vm.getPaesi_SL()
                    , vm.getProvince_SL()
                    , vm.getTIndirizzi_SL()
                    , vm.getProvince_M7_INPS()
                    , vm.getProvince_M7_INAIL()
                ];
                return common.activateController(promises, controllerId)
                    .then(function () {
                        
                        vm.sectionMenu = sectionMenu.setSection(vm.title);
                        vm.activated = true;

                        return cerca();
                    });
            }
        }

        //****************************************************
        // METODI GESTIONE AUTORIZZAZIONI
        //****************************************************
        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function (data) {
                //Auth. specifica
                vm.isSpecial = (vm.isSUPER || vm.isIstruttore || vm.isCIAPI);
            });
        }

        //****************************************************
        // METODI GESTIONE ELENCO
        //****************************************************


        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.iStato = vm.fIStato == null ? 0 : vm.fIStato;
            vm.filter.progettoId = vm.fProgettoId == null ? 0 : vm.fProgettoId;
            vm.filter.misuraCode = vm.fMisuraCode == null ? '' : vm.fMisuraCode;

            vm.loading = false;

            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.cndAccreditamento_countAll(0, vm.filter.testuale, 0, 0, 0, -1, vm.email, vm.codiceFiscale, vm.filter.iStato, vm.filter.progettoId, vm.filter.misuraCode)
                .then(function (data) {
                    if (data) {
                        vm.countRecords = data;
                    }
                });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;

            return datacontext.cndAccreditamento_getAll(vm.pageSize, vm.page, 0, vm.filter.testuale, 0, 0, 0, -1, vm.email, vm.codiceFiscale, vm.filter.iStato, vm.filter.progettoId, vm.filter.misuraCode, vm.ordine)
                .then(function (data) {
                    if (data.constructor === Array) {
                        vm.page++;
                        data.forEach(function (item) {
                            var subject = 'Link%20di%20accesso%20alla%20domanda';
                            var urlRoot = datacontext.accred_getURL();
                            var body = 'Salve,%0Dil%20link%20per%20accedere%20alla%20sua%20domanda%20e\'%20il%20seguente:%0D%0D' + urlRoot + 'CNDAccred7/' + item.ProgettoUId + '/' + item.UID + '%0D%0DCordiali%20saluti.';
                            item.MailTo1 = 'mailto:' + item.SedeLeg_Email + '?subject=' + subject + '&body=' + body;
                            vm.records.push(item);
                        });
                    }
                    vm.loading = false;
                });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getProject(id) {
            return datacontext.cndProgetto_get(id).then(function (data) {

                vm.cndProgetto = data;
                //console.info('getCNDProgetto', data);
                var dt = new Date(vm.cndProgetto.DttmServer);
                var dtStart = new Date(vm.cndProgetto.DtStart);
                var dtEnd = new Date(vm.cndProgetto.DtEnd);

                vm.ore_disp = moment(dtEnd).format('LT');
                //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                vm.isClickDay = vm.cndProgetto.IsClickDay;
                vm.endTime = vm.dtStartClickDay;
                vm.countdown = ((vm.dtStartClickDay - dt) / 1000);

                if (dt < dtStart) {
                    showAlertDivs('enableBeforeStart');
                } else if (dt > dtEnd) {
                    showAlertDivs('callExpired');
                } else {
                    showAlertDivs('');
                }

                sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                sectionMenu.setLabelCF('Codice Fiscale');

                vm.record.ProgettoId = vm.cndProgetto.Id;

                return true;
            });
        }

        function getRecord(id, index) {
            vm.index = index;
            return datacontext.cndAccreditamento_get(id).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }

                setRecord(data); //vm.record = data;
                setStepDefault();
                //console.info('vm.record', vm.record);
            });
        }

        vm.unlockItem = function (index) {
            if (!index) return;

            var item = vm.record;
            var msg = 'Sei sicuro di voler sbloccare la domanda: ' + item.UID + ' ? ';
            switch (index) {
                case 1:
                    vm.record.Completed = false;
                    msg = msg + ' Attenzione, proseguendo verranno eliminati gli allegati associati. ';
                    break;
                case 2:
                    vm.record.AttachChecked = false;
                    break;
                case 3:
                    vm.record.Sent = false;
                    break;
                case 31:
                    vm.record.Sent = false;
                    vm.record.DeepRicevuta = true;
                    break;
                case 4:
                    vm.record.bConvalida = false;
                    break;
                case 5:
                    vm.record.SentPEC = false;
                    break;
            }

            bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                function () { //YES
                    return datacontext.cndAccreditamento_unlock(item).then(function (data) {
                        if (data == "404") return logError('Errore: operazione non consentita');
                        setRecord(data);
                        vm.records[vm.index] = vm.record;
                        switch (index) {
                            case 1:
                                setStep(1);
                                break;
                            case 2:
                                setStep(2);
                                break;
                        }

                    });
                },
                function () { //NO
                    switch (index) {
                        case 1:
                            vm.record.Completed = true;
                            break;
                        case 2:
                            vm.record.AttachChecked = true;
                            break;
                        case 3:
                        case 31:
                            vm.record.Sent = true;
                            vm.record.DeepRicevuta = false;
                            break;
                        case 4:
                            vm.record.bConvalida = true;
                            break;
                        case 5:
                            vm.record.SentPEC = true;
                            break;
                    }
                }
            );
        };

        vm.setStatusItem = function (index) {
            if (!index) return;
            var item = vm.record;
            switch (index) {
                case 4:
                    vm.record.bConvalida = true;
                    var msg = 'Si sta rendendo la domanda presentata "IDONEA". Continuare? ';
                    bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                        function () { //YES
                            return datacontext.cndAccreditamento_setStatus(item).then(function (data) {
                                if (data == "404") return logError('Errore: operazione non consentita');
                                vm.record.bConvalida = true;
                                //setRecord(data);
                                //vm.records[vm.index] = vm.record;
                                //setStep(3);
                            });
                        },
                        function () { //NO
                            vm.record.bConvalida = false;
                        }
                    );
                    break;
                case 5:
                    vm.record.SentPEC = true;
                    var msg1 = 'Proseguendo verranno richiesti i dati di trasmissione della domanda tramite PEC. Continuare? ';
                    bDialog.confirmationDialog('Attenzione', msg1, 'OK').then(
                        function () { //YES
                            modalSentPEC();
                        },
                        function () { //NO
                            vm.record.SentPEC = false;
                        }
                    );
                    break;
            }

        };

        vm.modalSentPEC = function () {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/BO/modal/sentPEC.html?version=127',
                controller: 'sentPEC',
                backdrop: 'static',
                resolve: {
                    accreditamento: function () {
                        return vm.record;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "404") return logError('Errore: operazione non consentita');
                vm.record.SentPEC = true;
                vm.records[vm.index] = vm.record;
            }, function () {
                vm.record.SentPEC = false;
            });
        };


        //****************************************************
        // METODI GESTIONE VIEW
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function nextStep() {
            if (vm.isSuperUSER) {
                setStep(vm.actualStep + 1);
            }
            else {
                bDialog.confirmationDialog('Attenzione', 'Si sta passando alla Fase successiva, se le modifiche non sono state salvate, verrano perse. Procedere? ', 'Ok').then(
                    function () { //YES
                        setStep(vm.actualStep + 1);
                    },
                    function () { //NO
                        //
                    }
                );
            }
        }

        function prevStep() {
            setStep(vm.actualStep - 1);
        }

        function loadStepParams() {
            vm.labelsStep = [];
            vm.titlesStep = [];
            vm.subtitlesStep = [];
            vm.descriptionsStep = [];

            vm.labelsStep[0] = "A";
            vm.titlesStep[0] = "Fase A";
            vm.subtitlesStep[0] = "Manifestazione di interesse";
            vm.descriptionsStep[0] = "&Egrave; richiesto l'inserimento dei dati necessari alla compilazione degli Allegati 2 e 3.<br/>&Egrave; possibile procedere alla fase successiva solo dopo aver inserito e salvato tutte le informazioni richieste in questa fase.";

            vm.labelsStep[1] = "B";
            vm.titlesStep[1] = "Fase B";
            vm.subtitlesStep[1] = "Sedi Accreditate e Settori";
            vm.descriptionsStep[1] = "&Egrave; richiesto l'inserimento delle sedi operative autorizzate/accreditate per la realizzazione delle attivit&agrave; oggetto del presente Avviso.<br />&Egrave;, inoltre, necessario inserire il/i settore/i della produzione di beni, fornitura di servizi e commercio, anche in forma di franchising e le informazioni relative al numero di percorsi che si intende attivare, il numero di destinatari e l'importo complessivo.";

            vm.labelsStep[2] = "C";
            vm.titlesStep[2] = "Fase C";
            vm.subtitlesStep[2] = "Upload Documentale";
            vm.descriptionsStep[2] = "Occore scaricare gli Allegati 2 e 3, generati dal portale, firmarli e ricaricarli unitamente all'altra documentazione richiesta, compilando integralmente l'elenco.";

            vm.labelsStep[3] = "D";
            vm.titlesStep[3] = "Fase D";
            vm.subtitlesStep[3] = "Stampa ricevuta";
            vm.descriptionsStep[3] = "&Egrave; possibile stampare la 'Ricevuta di accreditamento' che contiene il numero di istanza di accreditamento.";
        }

        function setStepDefault() {
            if (vm.record.AttachChecked) {
                setStep(3);
            } else if (vm.record.Completed) {
                setStep(2);
            } else if (vm.record != undefined && vm.record.Sedi != undefined && vm.record.Sedi.length > 0) {
                setStep(1);
            } else {
                setStep(0);
            }
        }

        function setStep(actualStep) {

            if (actualStep >= vm.maxStep)
                actualStep = vm.maxStep - 1;

            if (actualStep < 0)
                actualStep = 0;

            vm.actualStep = actualStep;
            vm.subStep = "";
            switch (vm.actualStep) {
                case 0:
                    setView('viewAccred');
                    break;
                case 1:
                    setView('viewSede');
                    break;
                case 2:
                    populateAttach();
                    setView('viewAtt');
                    break;
                case 3:
                    setView('viewRiep');
                    break;
            }

            vm.labelStep = vm.labelsStep[vm.actualStep];
            vm.titleStep = vm.titlesStep[vm.actualStep];
            vm.subtitleStep = vm.subtitlesStep[vm.actualStep];
            vm.descriptionStep = vm.descriptionsStep[vm.actualStep];
            setClassSeqWiz();

        }


        function setClassSeqWiz() {
            vm.classStep = [];
            vm.classStepIcon = [];
            vm.classStepComplete = [];
            vm.stepEdit = [];
            vm.stepCompleted = [];


            var cssEdit = 'blue';
            var cssCompleted = 'green';
            var cssDefault = 'gray';
            var cssLast = 'last';

            var faIconEdit = 'fa fa-pencil';
            var faIconComplete = 'fa fa-check';
            var faIconDefault = '';

            var cssStepComplete = 'step-complete';

            var spanEdit = 'span-select';
            var spanDefault = '';

            vm.stepEdit[vm.actualStep] = true;
            vm.stepCompleted[0] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[1] = vm.record != undefined && vm.record.Completed;
            vm.stepCompleted[2] = vm.record != undefined && vm.record.AttachChecked;
            vm.stepCompleted[3] = vm.record != undefined && vm.record.Sent;

            for (var i = 0; i < vm.maxStep; i++) {

                //Seconda Gestione
                //CLASS STEP
                vm.classStep[i] = '';
                if (vm.stepEdit[i]) // se � in edit
                    vm.classStep[i] = cssEdit;
                else // altrimenti
                    vm.classStep[i] = cssDefault;

                if (i + 1 == vm.maxStep) // se sono nell'ultima fase
                    vm.classStep[i] = cssLast + '-' + vm.classStep[i];
                else if (vm.stepEdit[i + 1]) // se � in edit
                    vm.classStep[i] = vm.classStep[i] + '-' + cssEdit;
                else // altrimenti
                    vm.classStep[i] = vm.classStep[i] + '-' + cssDefault;


                //ICON STEP
                vm.classStepIcon[i] = '';
                if (vm.stepCompleted[i]) // se � completed
                    vm.classStepIcon[i] = faIconComplete;
                else if (vm.stepEdit[i]) // se � in edit
                    vm.classStepIcon[i] = faIconEdit;

                //ICON STEP COMPLETE
                vm.classStepComplete[i] = '';
                if (vm.stepCompleted[i] && !vm.stepEdit[i]) // se � completed
                    vm.classStepComplete[i] = cssStepComplete;
            }
        }

        function isAblePrevButton() {
            //Inserire qui i casi in cui non � abilitata la fase successiva
            return vm.actualStep > 0;
        }
        function isAbleNextButton() {
            var able = false;
            //Inserire qui i casi in cui non � abilitata la fase successiva
            switch (vm.view) {
                case 'viewAccred':
                    if (vm.record.Id > 0)
                        able = true;
                    break;
                case 'viewSede':
                    if (
                        (vm.record.Sedi != undefined && vm.record.Sedi[0] != undefined && vm.record.Sedi[0].Id > 0 || vm.list.cndAccredSedi != undefined && vm.list.cndAccredSedi.length > 0)
                            &&
                        (vm.record.M7_Settori != undefined && vm.record.M7_Settori[0] != undefined && vm.record.M7_Settori[0].Id > 0 || vm.list.cndAccredSettori != undefined && vm.list.cndAccredSettori.length > 0)
                    )
                        able = true;
                    break;
                case 'viewAtt':
                    if (vm.record != undefined && vm.record.Completed)
                        able = true;
                    break;
            }

            return vm.actualStep < (vm.maxStep - 1) && able;
        }

        function isAbleSaveButton() {
            var disable = false;

            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid || vm.saving;
            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.record.Completed;
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    disable = vm.saving || vm.record.Completed;
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto salva
                    break;
            }

            return !disable;
        }
        function isAbleAddButton() {
            var disable = false;
            var form = document.forms[vm.view];
            //console.info('form', vm.view, form.$pristine, form.$invalid, vm.saving, form);
            //disable = form.$pristine || form.$invalid

            switch (vm.actualStep) {
                case 0:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 1:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 2:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 3:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
                case 4:
                    //Inserire qui i casi in cui non � abilitato il tasto Add
                    break;
            }

            return !disable;
        }

        function isVisiblePrevButton() {
            return true;
        }
        function isVisibleNextButton() {
            return true;
        }
        function isVisibleSaveButton() {
            return true;
        }

        function setShowInfoMsg() {
            return vm.showInfoMsg = !vm.showInfoMsg;
        }

        //Gestione per viewAccred
        function setShowPanelAccred1() {
            return vm.showPanelAccred1 = !vm.showPanelAccred1;
        }
        function setShowPanelAccred2() {
            return vm.showPanelAccred2 = !vm.showPanelAccred2;
        }
        function setShowPanelAccred3() {
            return vm.showPanelAccred3 = !vm.showPanelAccred3;
        }
        function setShowPanelAccred4() {
            return vm.showPanelAccred4 = !vm.showPanelAccred4;
        }

        //Gestione per viewSede
        function setShowPanelSede1() {
            return vm.showPanelSede1 = !vm.showPanelSede1;
        }
        function setShowPanelSede2() {
            return vm.showPanelSede2 = !vm.showPanelSede2;
        }

        //Gestione per viewAtt
        function setShowPanelAtt1() {
            return vm.showPanelAtt1 = !vm.showPanelAtt1;
        }
        function setShowPanelAtt2() {
            return vm.showPanelAtt2 = !vm.showPanelAtt2;
        }
        function setShowPanelAtt3() {
            return vm.showPanelAtt3 = !vm.showPanelAtt3;
        }

        //Gestione per viewRiep
        function setShowPanelRiep1() {
            return vm.showPanelRiep1 = !vm.showPanelRiep1;
        }


        function getCNDProgetto(cndProgettoUID) {
            return datacontext.cndProgetto_getByUID(cndProgettoUID)
                .then(function (data) {
                    if (data.UID != cndProgettoUID) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    } else { //Codice Progetto corretto
                        vm.cndProgetto = data;
                        //console.info('getCNDProgetto', data);
                        var dt = new Date(vm.cndProgetto.DttmServer);
                        var dtStart = new Date(vm.cndProgetto.DtStart);
                        var dtEnd = new Date(vm.cndProgetto.DtEnd);

                        vm.ore_disp = moment(dtEnd).format('LT');
                        //if (vm.ore_disp == "00:00") vm.ore_disp = "24:00";
                        if (vm.ore_disp == "23:59") vm.ore_disp = "24:00";
                        vm.data_disp = moment(dtEnd).format("DD MMMM YYYY");


                        vm.dtStartClickDay = new Date(vm.cndProgetto.DtStartClickDay);
                        vm.dtEndClickDay = new Date(vm.cndProgetto.DtEndClickDay);

                        vm.isClickDay = vm.cndProgetto.IsClickDay;

                        vm.endTime = vm.dtStartClickDay;
                        vm.countdown = (vm.dtStartClickDay - dt) / 1000;

                        if (dt < dtStart) {
                            showAlertDivs('enableBeforeStart');
                        } else if (dt > dtEnd) {
                            showAlertDivs('callExpired');
                        } else {
                            showAlertDivs('');
                        }


                        sectionMenu.setUrlLogoHeader(vm.cndProgetto.LogoHeader);
                        sectionMenu.setLnkPDFBando(vm.cndProgetto.LnkPDFBando);
                        sectionMenu.setLnkPDFManuale(vm.cndProgetto.LnkPDFManuale);
                        sectionMenu.setLnkOfficialSite(vm.cndProgetto.LnkOfficialSite);
                        sectionMenu.setTipoCandidatura(vm.cndProgetto.iTipoCandidatura);
                        sectionMenu.setLabelCF('Codice Fiscale');
                        sectionMenu.setProjectUID(vm.cndProgetto.UID);

                        vm.record.ProgettoId = vm.cndProgetto.Id;
                    }

                },
                    //else
                    function (data) {
                        vm.cndProgetto = {};
                        showAlertDivs('linkError');
                    }
                );
        }

        $scope.$on('timer-tick', function (event, args) {
            if (args.millis == 0) {
                //console.info('timer-tick', args.millis);
                //vm.isClickDay = true;
            }
        });


        vm.setProtSent = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/BO/modal/richAccredProtSent.html?version=127',
                controller: 'richAccredProtSent7',
                backdrop: 'static',
                resolve: {
                    accreditamento: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSUPER || vm.isUMC || vm.isCIAPI || vm.isFAM;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (!returnItem) return logError('Errore. ');
                vm.records[index] = returnItem;
                logSuccess('Istanza protocollata con successo! ');
            }, function () {
                //
            });
        };

        vm.unsetProtSent = function (item, index) {
            if (item.NumProtSent != null && item.NumProtSent != "") {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo il protocollo dell\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        return datacontext.cndAccreditamento_unsetProtSent(item).then(function (data) {
                            if (data == '404') return logError('Errore di aggiornamento stato. ');
                            if (typeof data == 'undefined') return logError('Errore. ');

                            return vm.records[index] = data;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.setConvalida = function (item, index) {
            //if (!item.Convalida) {
            //    bDialog.confirmationDialog('Attenzione', 'Si sta convalidando l\'istanza. Proseguire?', 'OK').then(
            //        function () { //YES
            //            item.Convalida = true;
            //            return datacontext.partecipazione_setConvalida(item).then(function (data) {
            //                if (typeof data == 'undefined') return logError('Errore. ');
            //                return vm.records[index] = data;
            //            });
            //        },
            //        function () { //NO

            //        }
            //    );
            //}
            //vm.getAccredSedi(item.Id).then(function () {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/BO/modal/accredConvalida.html?version=127',
                controller: 'accredConvalida7',
                backdrop: 'static',
                resolve: {
                    accreditamento: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSUPER || vm.isUMC || vm.isCIAPI || vm.isFAM;
                    },
                    sedi: function () {
                        return item.Sedi;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return logError('Errore Aggiornamento');
                if (!returnItem) return logError('Errore. ');
                vm.records[index] = returnItem;
                logSuccess('Istanza convalidata con successo! ');
            }, function () {
                //
            });
            // });

        };

        vm.unsetConvalida = function (item, index) {
            if (item.iConvalida != 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta rimuovendo la convalida dall\'istanza. Proseguire?', 'OK').then(
                    function () { //YES
                        item.iConvalida = 0;
                        return datacontext.cndAccreditamento_unsetConvalida(item).then(function (data) {
                            if (typeof data == 'undefined') return logError('Errore. ');
                            return vm.records[index] = data;
                        });
                    },
                    function () { //NO

                    }
                );
            }
        };

        vm.accredInfoEditAmmiss = function (item, index) {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/BO/modal/accredInfoEditAmmiss.html?version=127',
                controller: 'accredInfoEditAmmiss7',
                backdrop: 'static',
                resolve: {
                    accreditamento: function () {
                        return item;
                    },
                    isSuper: function () {
                        return vm.isSUPER || vm.isUMC || vm.isCIAPI || vm.isFAM;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == '400') return logError('Errore Aggiornamento');
                if (!returnItem) return logError('Errore. ');
                vm.records[index] = returnItem;
                logSuccess('Note aggiornate! ');
            }, function () {
                //
            });
        };

        vm.setCompleted = function () {
            if (!vm.record.Sent && !vm.record.Completed) {
                bDialog.confirmationDialog('Attenzione', 'Questa operazione comporta la convalida delle informazioni inserite nella "Fase A" e nella "Fase B", pertanto non sar\xE0 possibile apportare modifiche successivamente. Vuoi convalidare e procedere?', 'OK').then(
                    function () { //YES
                        vm.record.Completed = true;
                        vm.PdfReady = false;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Completed = false;
                                return true;
                            }
                            setClassSeqWiz();
                            setStep(2);
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(1);
                    }
                );
            }
            else {
                nextStep();
            }
        };

        vm.setSent = function () {
            if (!vm.record.Sent) {
                bDialog.confirmationDialog('Attenzione', 'La stampa della "Ricevuta" equivale a dichiarare terminata tutta la procedura telematica; pertanto non sar\xE0 possibile modificare o caricare altri documenti.', 'Procedi').then(
                    function () { //YES
                        vm.record.Sent = true;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.Sent = false;
                                return true;
                            }
                            setClassSeqWiz();
                            vm.printRicevuta();
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            }
            else {
                vm.printRicevuta();
            }
        };

        vm.setAttachChecked = function () {
            if (!vm.record.AttachChecked) {
                bDialog.confirmationDialog('Attenzione', 'Si sta proseguendo alla "Fase D", pertanto, non sar\xE0 possibile tornare indietro e/o aggiungere, modificare, eliminare gli allegati caricati a sistema. Procedere? ', 'Procedi').then(
                    function () { //YES
                        vm.record.AttachChecked = true;
                        vm.loading = true;
                        return saveOrUpdateAccred().then(function (data) {
                            vm.loading = false;
                            if ($.isNumeric(data)) {
                                vm.record.AttachChecked = false;
                                setStep(2);
                                return false;
                            }
                            setClassSeqWiz();
                            setStep(3);
                            //setView('viewRiep');
                            return true;
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                        setStep(2);
                        return true;
                    }
                );
            }
            else {
                if (vm.isSuperUSER) {
                    setClassSeqWiz();
                    setStep(3);
                }
            }

        };



        //*******************************
        // Print PDF ACCREDITAMENTOs

        vm.printAll = function (index) {
            if (typeof index == 'undefined')
                index = 0;
            vm.loading = true;
            $('#loadingModal').modal('show');
            return datacontext.cndAccreditamento_printAll(vm.record.ProgettoUId, vm.record.UID, '7', index)
                .then(function (data) {
                    $('#loadingModal').modal('hide');
                    vm.loading = false;
                    if (data && data.url) {

                        var iAllegato = 2;
                        if (index == 1) {
                            iAllegato = 3;
                        }

                        var url = data.url;
                        var name = 'Allegato' + (iAllegato) + '_UID' + vm.record.UID + '.pdf';

                        window.open(url, name);

                        //recupero allegato appena creato
                        //var a = document.createElement("a");
                        //a.setAttribute('style', 'display:none');
                        //a.setAttribute('target', '_blank');
                        //document.body.appendChild(a);

                        //var iAllegato = 2;
                        //if (index == 1) {
                        //    iAllegato = 3;
                        //}
                        //a.href = data.url;
                        //if ($rootScope.detectIE()) {
                        //    a.target = 'hiddenIframe';
                        //}
                        //else
                        //    a.download = 'Allegato' + (iAllegato) + '_UID' + vm.record.UID + '.pdf';
                        //a.click();
                        //document.body.removeChild(a);

                        return vm.linkPDFAllA = data.url;
                    } else
                        return true;
                });
        };

        vm.printRicevuta = function () {
            if (vm.record.Sent) {
                vm.loading = true;
                $('#loadingModal').modal('show');
                return datacontext.cndAccreditamento_printRicevuta(vm.record.ProgettoUId, vm.record.UID, '7')
                    .then(function (data) {
                        $('#loadingModal').modal('hide');
                        vm.loading = false;
                        if (data && data.url) {

                            var url = data.url;
                            var name = 'Ricevuta_UID' + vm.record.UID + '.pdf';

                            window.open(url, name);

                            //recupero allegato appena creato
                            //var a = document.createElement("a");
                            //a.setAttribute('style', 'display:none');
                            //a.setAttribute('target', '_blank');
                            //document.body.appendChild(a);

                            //a.href = data.url;
                            //if ($rootScope.detectIE()) {
                            //    a.target = 'hiddenIframe';
                            //}
                            //else
                            //    a.download = 'Ricevuta_UID' + vm.record.UID + '.pdf';
                            //a.click();
                            //document.body.removeChild(a);

                            getRecordByUID(vm.record.UID);
                            return vm.linkPDFRicevuta = data.url;
                        } else
                            return true;
                    });
            }
        };

        function setRecord(data) {
            vm.record = data;

            //Carico l'elenco delle sedi accreditate
            vm.CNDAccredSede_getAll(vm.record.ProgettoId, vm.record.Id);
            vm.CNDAccredSettore_getAll(vm.record.ProgettoId, vm.record.Id);

            if (vm.record.Completed)
                return;

            //Abilita questo codice solo per sistemazioni grafiche della comunicazione Link di Accesso
            vm.isVisibleLinkDomanda = true;

            //console.info('setRecord', vm.record);
            //Reset campi Notifiche
            vm.validFieldsCF = true;
            vm.validPIVA = true;
            vm.validCF = true;
            vm.exixstsPIVA = false;
            vm.exixstsCF = false;

            if (vm.record.L_DtNasc != null) vm.record.L_DtNasc = new Date(vm.record.L_DtNasc);
            if (vm.record.DDG_Dt != null) vm.record.DDG_Dt = new Date(vm.record.DDG_Dt);
            if (vm.record.SedeLeg_Email != null) vm.confirm.SedeLeg_Email = vm.record.SedeLeg_Email;
            if (vm.record.SedeLeg_PEC != null) vm.confirm.SedeLeg_PEC = vm.record.SedeLeg_PEC;

            //Azzera liste
            vm.list.attach = [];
            vm.list.b_attach = false;

            //Aggiorno campi
            vm.getComuni_SL(vm.record.ProvinciaId);
            vm.getComuni_LNasc(vm.record.L_ProvNascId);
            vm.getComuni_LRes(vm.record.L_ResProvinciaId);
            vm.getComuni_M7_INPS(vm.record.M7_INPS_ProvinciaId);
            vm.getComuni_M7_INAIL(vm.record.M7_INAIL_ProvinciaId);

            getAteco(vm.record.TAtecoId);

            vm.myPristine = true;
            vm.changeForm = false;
        }

        function showAlertDivs(errorAccess) {
            var msg = '';

            vm.errorAccess = errorAccess;

            if (errorAccess == 'linkError') {
                msg = 'Attenzione! Il link utilizzato e\' errato.';
            }

            if (msg != '') return logError(msg);

            return false;
        }

        function getRecordByUID(uid) {
            return datacontext.cndAccreditamento_getByUID(uid, vm.record.ProgettoUId).then(function (data) {
                if (data == null || $.isNumeric(data) || data.Id == 0) {
                    showAlertDivs('linkError');
                    return false;
                }

                vm.myPristine = false;
                //Parametro di appoggio per send_Email
                vm.record.ProgettoUId = $routeParams.projectUID;
                //Riduco il pannello con le modalit� di utilizzo dello strumento
                vm.showInfoMsg = false;

                setRecord(data); //vm.record = data;
                setStepDefault();
            });
        }

        function saveOrUpdateAccred() {
            unResetAccred(vm.record);
            var msgExistAccr = 'Attenzione: tentativo di duplicazione. La "Partita IVA" dell\'azienda \xE8 gi\xE0 presente a sistema. ';
            if (typeof (vm.record.Id) == 'undefined' || vm.record.Id == null || vm.record.Id == 0) {
                bDialog.confirmationDialog('Attenzione', 'Si sta effettuando il primo salvataggio; la pratica sar\xE0 acquisita nel sistema informativo. Procedere?', 'OK').then(
                    function () { //YES
                        //Parametro di appoggio per send_Email
                        vm.record.ProgettoUId = vm.cndProgetto.UID;
                        vm.record.iFinestra = vm.iFinestra;
                        vm.loading = true;
                        return datacontext.cndAccreditamento_add(vm.record).then(function (data) {
                            vm.loading = false;
                            if (data == "400") {
                                logError('Errore campi non validi. ');
                                return data;
                            }
                            if (data == "304") {
                                logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                                return data;
                            }
                            if (data == "409") {
                                logError(msgExistAccr); //Domanda esistente
                                return data;
                            }
                            if (data == "300") {
                                logError('Errore: partita IVA non valida. ');
                                return data;
                            }
                            if (data == "501") {
                                logError('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if (data == "203") {
                                logError('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                                return data;
                            }
                            if (data == "403") {
                                logError("Attenzione: l'\importo complessivo deve essere compreso, tra un minimo di 2000 e un massimo di 2400, per il numero di destinatari!");
                                return data;
                            }
                            if (data == "502") {
                                return logError('Attenzione: la stampa della "ricevuta" non \xE8 ancora permessa, in quanto non \xE8 il periodo utile.');
                            }
                            if ($.isNumeric(data)) {
                                logError('Errore non specificato. Impossibile registrare i dati inseriti.');
                                return data;
                            }

                            if (data) {
                                setRecord(data); //vm.record = data;
                                vm.myPristine = true;
                                vm.changeForm = false;
                                //console.info('saveOrUpdateAccred', vm.myPristine);

                                //$routeParams.accreditamentoUID = vm.record.UID;

                                if (vm.record.Id > 0) {
                                    //Riduco il pannello con le modalit� di utilizzo dello strumento
                                    vm.showInfoMsg = false;
                                }
                                return logSuccess('E\' stata inviata una email all\'indirizzo ' + vm.record.Email + ' con il link ai dati inseriti. ');
                            }
                        });
                    },
                    function () { //NO
                        vm.loading = false;
                    }
                );
            } else {
                vm.loading = true;
                return datacontext.cndAccreditamento_update(vm.record).then(function (data) {
                    vm.loading = false;
                    if (data == "304") {
                        logError('Attenzione "BANDO SCADUTO". Modifica dati non permessa. ');
                        return data;
                    }
                    if (data == "300") {
                        logError('Errore: partita IVA non valida. ');
                        return data;
                    }
                    if (data == "406") {
                        vm.record.AttachChecked = false;
                        logError("Attenzione mancano alcuni allegati necessari, inserirli prima di passare alla Fase successiva. ");
                        return data;
                    }
                    if (data == "409") {
                        logError(msgExistAccr); //Domanda esistente
                        return data;
                    }
                    if (data == "501") {
                        logError('Errore: codice fiscale del "Rappresentante Legale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "203") {
                        vm.saving = false;
                        logError('Errore: codice fiscale del "Tutor Professionale" non valido. Si verifichino i campi corrispondenti ');
                        return data;
                    }
                    if (data == "406") {
                        logError('Errore: allegato non disponibile ');
                        return data;
                    }
                    if (data == "502") {
                        logError('Attenzione: la stampa della "ricevuta" non \xE8 ancora permessa, in quanto non \xE8 il periodo utile.');
                        return data;
                    }
                    if (data == "403") {
                        return logError("Attenzione: l'\importo complessivo deve essere compreso, tra un minimo di 2000 e un massimo di 2400, per il numero di destinatari!");
                        return data;
                    }

                    if ($.isNumeric(data)) {
                        logError('Errore generico. Impossibile proseguire.');
                        return data;
                    }

                    if (data) {
                        setRecord(data); //vm.record = data;
                        vm.myPristine = true;
                        vm.changeForm = false;
                        //$routeParams.accreditamentoUID = vm.record.UID;
                        logSuccess('Dati salvati');
                        return true;
                    }
                });
            }
        }

        function unResetAccred(item) {
            if (item.L_PaeseNascId > 0) {
                item.L_ProvNascId = 0;
                item.L_ComuneNascId = 0;
            }

            if (item.L_ResPaeseId > 0) {
                item.L_ResProvinciaId = 0;
                item.L_ResComuneId = 0;
            }

            if (!item.L_CittadinanzaId) {
                item.L_CittadinanzaId = 0;
            }
        }

        function deleteItem(item) {
            var msg = ' la azienda : ' + item.RagioneSociale;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamento_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }

        function downloadItem(item) {
            $('#loadingModal').modal('show');
            return datacontext.attach_download(item.Id, vm.tSourceCode_ACCR, 0, 0).then(function (data) {
                $('#loadingModal').modal('hide');
                if (data == '') return logError('Documentazione non disponibile.');
                var url = data;
                window.open(url, 'Download');
            });
        }

        vm.setAnnulled = function (locked) { //Se locked==true => 'Annullo' l'istanza; altrimenti la 'Riabilito'
            if (vm.record != null && vm.record.Id > 0) {
                var msg = 'Stai per annullare l\'istanza di ' + vm.record.L_CodiceFiscale + '. Procedere?';
                if (!locked) msg = 'Stai per riabilitare l\'istanza di ' + vm.record.L_CodiceFiscale + '. Procedere?';
                bDialog.confirmationDialog('Attenzione', msg, 'OK').then(
                    function () { //YES
                        return datacontext.cndAccreditamento_setAnnulled(vm.record.Id, locked).then(function (data) {
                            if (data == "304") {
                                return logError('Errore sul "setAnnulled". ');
                            }
                            else {
                                vm.record.Annulled = locked;
                                vm.records[vm.index].Annulled = locked;

                                return logSuccess('Record modificato. ');
                            }
                        });
                    },
                    function () { //NO
                        //
                    }
                );
            }
        };

        vm.modalAnnulled = function () {
            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/BO/modal/accrAnnulled.html?version=127',
                controller: 'accrAnnulled',
                backdrop: 'static',
                resolve: {
                    accreditamento: function () {
                        return vm.record;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "404") return logError('Errore: operazione non consentita');
                vm.record.Annulled = true;
                vm.records[vm.index] = vm.record;
            }, function () {
                vm.record.Annulled = false;
            });
        };

        /**************************************/

        // -- ATTUAZIONE
        vm.change_Privato = function () {
            if (!vm.record.M7_bPrivato) {
                vm.record.M7_bCooperativa = false;
                vm.record.M7_iLegge6899 = 0;
                vm.record.M7_INPS_Code = '';
                vm.record.M7_INPS_Matricola = '';
                vm.record.M7_INPS_ProvinciaId = '';
                vm.change_Comuni_M7_INPS(vm.record.M7_INPS_ProvinciaId);
                vm.record.M7_INAIL_Code = '';
                vm.record.M7_INAIL_Matricola = '';
                vm.record.M7_INAIL_ProvinciaId = '';
                vm.change_Comuni_M7_INAIL(vm.record.M7_INAIL_ProvinciaId);
            }
        };

        vm.change_M7_bNoPIVA = function () {
            if (vm.record.M7_bNoPIVA) {
                vm.record.PIVA = '';
            }
        }

        vm.change_M7_bNoDip = function () {
            if (vm.record.M7_bNoDip) {
                vm.record.M7_INPS_Code = '';
                vm.record.M7_INPS_Matricola = '';
                vm.record.M7_INPS_ProvinciaId = '';
                vm.record.M7_INPS_ComuneId = '';
                vm.record.M7_INAIL_Code = '';
                vm.record.M7_INAIL_Matricola = '';
                vm.record.M7_INAIL_ProvinciaId = '';
                vm.record.M7_INAIL_ComuneId = '';
            }
        }

        vm.restore = function (item) {
            bDialog.confirmationDialog('Attenzione', 'Si stanno per reinizializzare i campi ricevuta e protocollo. Proseguire?', 'OK').then(
                function () { //YES
                    return datacontext.cndAccreditamento_restore(item.Id).then(function (data) {
                        if (data == 0 || data == null || data == '' || typeof data == 'undefined') {
                            return logError('Error on Restore');
                        }

                        item.ProgressivoRicvevuta = 0;
                        item.CodiceRicvevuta = '';
                        item.DtRicvevuta = '';
                        item.NumProtSent = '';
                        item.OpProtSent = '';
                        item.DtProtSent = '';

                        var index = vm.records.indexOf(item);
                        if (index !== -1) {
                            vm.records[index] = item;
                        }

                        return logSuccess('Success on Restore');
                    });
                },
                function () { //NO

                }
            );
        };


        // Ateco per setRecord

        function getAteco(id) {
            return datacontext.tAteco_get(id).then(function (data) {
                //console.info('getAteco', data);
                if (data != null)
                    vm.record.searchTextAteco = data.Title;
            });
        }

        // #region GESTIONE ATTACH 2

        function resetListAttach() {
            vm.accr_ref = '';
            vm.list.attach_accr = [];
        }

        function populateAttach() {
            resetListAttach();

            if (vm.record != undefined && vm.record.Id != 0 && vm.record.Id != undefined) {
                vm.accr_ref = vm.record.L_Cognome + ' ' + vm.record.L_Nome + ' (' + vm.record.L_CodiceFiscale + ')';
                return getListAttach(vm.record.Id, vm.tSourceCode_ACCR).then(function (accr) {
                    vm.list.attach_accr = vm.list_ATT.slice();
                });
            }
        }

        // ATTACH 2
        function getListAttach(sourceId, tSourceCode) {
            if (!sourceId) return;
            vm.list_ATT = [];
            return datacontext.attach_getAll(0, 0, sourceId, 0, tSourceCode, 0, 0, '', vm.fAttach.TAttachId, 0, '').then(function (data_ATT) {
                vm.list.b_attach = true;
                if (!$.isNumeric(data_ATT)) vm.list_ATT = data_ATT;

                return datacontext.tAttach_getAll(0, 0, tSourceCode, 0, '', 0, '').then(function (data_TA) {
                    vm.tAttach_Needed = data_TA;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        vm.tAttach_Needed.forEach(function (item_TA) {
                            var att = {};
                            att.TAttachId = item_TA.Id;
                            att.TAttach = item_TA.Name;

                            if (typeof (vm.list_ATT) == 'undefined') vm.list_ATT = [];
                            var myrec = _.find(vm.list_ATT, { 'TAttachId': item_TA.Id });
                            var myTAV = _.find(tAttVis, { 'TAttachId': item_TA.Id });

                            if (typeof (myTAV) == 'undefined') {
                                myTAV = {};
                                myTAV.bRead = true;
                                myTAV.bInsert = true;
                                myTAV.bUpdate = true;
                                myTAV.bDelete = true;
                                myTAV.iTags = 0;
                            }

                            att.bRead = myTAV.bRead;
                            att.bInsert = myTAV.bInsert;
                            att.bUpdate = myTAV.bUpdate;
                            att.bDelete = myTAV.bDelete;
                            att.iTags = myTAV.iTags;

                            if (typeof (myrec) == 'undefined') {
                                if (att.bRead)
                                    vm.list_ATT.push(att);
                            }
                            else {
                                myrec.bRead = myTAV.bRead;
                                myrec.bInsert = myTAV.bInsert;
                                myrec.bUpdate = myTAV.bUpdate;
                                myrec.bDelete = myTAV.bDelete;
                                myrec.iTags = myTAV.iTags;

                                var items = _.groupBy(vm.list_ATT, { 'TAttachId': item_TA.Id });

                                items.true.forEach(function (i) {
                                    i.bRead = myTAV.bRead;
                                    i.bInsert = myTAV.bInsert;
                                    i.bUpdate = myTAV.bUpdate;
                                    i.bDelete = myTAV.bDelete;
                                    i.iTags = myTAV.iTags;
                                });

                                if (myrec.bInsert) {
                                    if (item_TA.MaxValue == 99 || item_TA.MaxValue > items.true.length)
                                        vm.list_ATT.push(att);
                                }
                            }
                        });
                        //console.info('vm.list_ATT', vm.list_ATT);
                        return vm.list_ATT;
                    });
                });
            });
        }

        function getTAttachNeeded(code) {
            if (!code) return;
            return datacontext.tAttach_getAll(0, 0, code, 0, '', 0, '').then(function (data) {

                return vm.tAttach_Needed = data;
            });
        }

        function getTSourceACCR() {
            return datacontext.tSource_getByCode(vm.tSourceCode_ACCR).then(function (data) {
                return vm.tSource_ACCR = data;
            });
        }

        function getTAttachNeededAccr() {
            if (vm.tAttach_ACCR.length > 0) return;
            return datacontext.tAttach_getAll(0, 0, vm.tSourceCode_ACCR, 0, '', 0, '').then(function (data) {
                //console.info('getTAttachNeededAccr', data);
                return vm.tAttach_ACCR = data;
            });
        }

        function deleteAttach(item) {
            var listATT = vm.list.attach_accr;
            var tSourceCode = vm.tSourceCode_ACCR;

            var msg = ' Allegato ' + item.Name;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.attach_delete(item.Id).then(function (data) {
                    if (data == "400") return logError('Attenzione: allegato non cancellabile! Contattare l\'Help-desk');
                    if (data == "417") return bDialog.errorDialog('Attenzione: azione non permessa, perch\xE8 entit\xE0 bloccata in cascata da altri elementi. ');

                    //Popolo l'oggetto att da cancellare
                    var index = listATT.indexOf(item);
                    var att = {};
                    att.TAttachId = listATT[index].TAttachId;
                    att.TAttach = listATT[index].TAttach;

                    return datacontext.tAttachVisibility_getAll(0, 0, tSourceCode).then(function (data_TAV) {
                        var tAttVis = data_TAV;

                        var myTAV = _.find(tAttVis, { 'TAttachId': att.TAttachId });

                        if (typeof (myTAV) == 'undefined') {
                            myTAV = {};
                            myTAV.bRead = true;
                            myTAV.bInsert = true;
                            myTAV.bUpdate = true;
                            myTAV.bDelete = true;
                            myTAV.iTags = 0;
                        }

                        att.bRead = myTAV.bRead;
                        att.bInsert = myTAV.bInsert;
                        att.bUpdate = myTAV.bUpdate;
                        att.bDelete = myTAV.bDelete;
                        att.iTags = myTAV.iTags;

                        vm.tAttach_Needed = [];
                        switch (tSourceCode) {
                            case 'ADES':
                                vm.tAttach_Needed = vm.tAttach_ADES;
                                break;
                            case 'ACCR':
                            case 'ACCR_1C3':
                            case 'ACCR_7':
                                vm.tAttach_Needed = vm.tAttach_ACCR;
                                break;
                        }

                        //Individuo la tipologia corrispondente
                        var item_TA = _.find(vm.tAttach_Needed, { 'Id': att.TAttachId });
                        //Raggruppo la lista per tipologia
                        var items = _.groupBy(listATT, { 'TAttachId': att.TAttachId });

                        //Se ho un allegato per la tipologia
                        if (items.true.length == 1 || item_TA.MaxValue == items.true.length) {
                            listATT[index] = att; //Ripulisco il record
                        }
                        else if (item_TA.MaxValue > items.true.length) {
                            //Rimuovo l'oggetto
                            listATT.splice(index, 1);
                        }
                    });
                });
            });
        }

        

        // ADD ATTACH2
        function addAttach(tAttachId) {
            var recTSource = { Id: vm.tSource_ACCR.Id, Name: vm.tSource_ACCR.Name };
            var recSource = { Id: vm.record.Id, Name: vm.accr_ref };

            var modalInstance = modal.open({
                templateUrl: '/app/ATT/attach/modal/attachAdd2.html?version=127',
                controller: 'attachAdd2',
                backdrop: 'static',
                resolve: {
                    tSource: function () {
                        return [recTSource];
                    },
                    tSourceCode: function () {
                        return vm.tSource_ACCR.Code;
                    },
                    tSourceId: function () {
                        return vm.tSource_ACCR.Id;
                    },
                    source: function () {
                        return [recSource];
                    },
                    sourceId: function () {
                        return recSource.Id;
                    },
                    tAttach: function () {
                        return vm.tAttach_ACCR;
                    },
                    tAttachId: function () {
                        return tAttachId;
                    },
                    tSourceRefId: function () {
                        return null;
                    },
                    sourceRefId: function () {
                        return null;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "406") return logError('Errore: tipologia di allegato non permessa! ');
                if (returnItem == "400") return logError('Errore registrazione dati');

                logSuccess('Dato salvato con successo! ');
                populateAttach();
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });

            return true;
        }

        //*****************************************************
        //Elenchi Parametri

        function getTSource(code) {
            if (!code) return;

            return datacontext.tSource_getByCode(code).then(function (data) {
                return vm.tSource = data;
            });
        }

        function getTAttach(code) {
            if (!code) return;

            return datacontext.tAttach_getAllList(code, 0, 0, 0).then(function (data) {
                return vm.tAttach = data;
            });
        }



        //Metodi interfaccia Filtri
        function setfAttach() {
            if (vm.checkfAttach == false) {
                vm.fAttach.TAttachId = '';
            }
        }

        // #endregion

        // #region SEDI

        //*************************************
        //cndAccreditamenti SEDI
        vm.CNDAccredSede_getAll = function (cndProgettoId, cndAccreditamentoId) {
            vm.list.cndAccredSedi = [];
            return datacontext.cndAccreditamentoSede_getAll(0, 0, '', cndProgettoId, cndAccreditamentoId, 0, 0, '').then(function (data) {
                return vm.list.cndAccredSedi = data;
            });
        };

        function CNDAccredSede_AddRecord(id) {
            return datacontext.cndAccreditamentoSede_get(id).then(function (data) {
                vm.list.cndAccredSedi.push(data);
            });
        }

        function CNDAccredSede_LoadRecord(item, index) {
            return datacontext.cndAccreditamentoSede_get(item.Id).then(function (data) {
                return vm.list.cndAccredSedi[index] = data;
            });
        }

        vm.CNDAccredSede_delete = function (item) {
            var msg = ' la sede in ' + item.TIndirizzo + ' ' + item.Indirizzo + ' ' + item.Civico + ' - ' + item.Comune;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamentoSede_delete(item.Id).then(function (data) {
                    if (data == "404") return logError('Errore cancellazione dati');

                    var index = vm.list.cndAccredSedi.indexOf(item);
                    vm.list.cndAccredSedi.splice(index, 1);
                });
            });
        };



        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************

        //Modal - cndAccreditamento Sede
        vm.addEditSede = function (item, index) {
            if (vm.record.Completed) return;
            if (typeof item == 'undefined')
                item = null;

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/FE/modal/cndAccredSedeAdd7.html?version=127',
                controller: 'cndAccredSedeAdd7',
                backdrop: 'static',
                resolve: {
                    cndAccredSede: function () {
                        return item;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    },
                    paesi: function () {
                        return vm.cmblist.L_Res_Paesi;
                    },
                    province: function () {
                        return vm.cmblist.L_Res_Province;
                    },
                    tIndirizzi: function () {
                        return vm.cmblist.L_Res_TIndirizzi;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                if (typeof item == 'undefined' || item == null) {
                    CNDAccredSede_AddRecord(returnItem.Id);
                } else {
                    CNDAccredSede_LoadRecord(returnItem, index);
                }

                logSuccess('Dato salvato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };


        //************************END*****************************

        //CNDSettori
        function getCNDSettori() {
            return datacontext.cndSettore_getAllList().then(function (data) {
                return vm.cmblist.cndSettori = data;
            });
        }

        //*************************************
        //cndAccreditamenti SETTORI
        vm.CNDAccredSettore_getAll = function (cndProgettoId, cndAccreditamentoId) {
            vm.list.cndAccredSettori = [];
            return datacontext.cndAccreditamentoSettore_getAll(0, 0, '', cndProgettoId, cndAccreditamentoId, 0, 0, '').then(function (data) {
                return vm.list.cndAccredSettori = data;
            });
        };

        function CNDAccredSettore_AddRecord(id) {
            return datacontext.cndAccreditamentoSettore_get(id).then(function (data) {
                vm.list.cndAccredSettori.push(data);
            });
        }


        function CNDAccredSettore_LoadRecord(item, index) {
            return datacontext.cndAccreditamentoSettore_get(item.Id).then(function (data) {
                return vm.list.cndAccredSettori[index] = data;
            });
        }

        vm.CNDAccredSettore_delete = function (item) {
            var msg = ' il settore: ' + item.CNDSettore;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndAccreditamentoSettore_delete(item.Id).then(function (data) {
                    if (data == "404") return logError('Errore cancellazione dati');

                    var index = vm.list.cndAccredSettori.indexOf(item);
                    vm.list.cndAccredSettori.splice(index, 1);
                });
            });
        };

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************

        //Modal - cndAccreditamento Settore
        vm.addEditSettore = function (item, index) {
            if (vm.record.Completed) return;
            if (typeof item == 'undefined')
                item = null;

            //console.info('vm.cmblist', vm.cmblist);

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDAccred7/FE/modal/cndAccredSettoreAdd.html?version=127',
                controller: 'cndAccredSettoreAdd',
                backdrop: 'static',
                resolve: {
                    cndAccredSettore: function () {
                        return item;
                    },
                    cndAccreditamentoId: function () {
                        return vm.record.Id;
                    },
                    progettoId: function () {
                        return vm.record.ProgettoId;
                    },
                    settori: function () {
                        return vm.cmblist.cndSettori;
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400") return logError('Errore di crezione! ');

                if (typeof item == 'undefined' || item == null) {
                    CNDAccredSettore_AddRecord(returnItem.Id);
                } else {
                    CNDAccredSettore_LoadRecord(returnItem, index);
                }

                logSuccess('Dato salvato con successo! ');
            }, function () {
                //log('Modal dismissed at: ' + new Date());
            });
        };
        //************************END*****************************

        // #endregion

        // #region FUNZIONI DI SUPPORTO

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- SUGGESTION PER CODICE ATECO -#-#-#-#-#-#
        //Define Suggestions List
        vm.suggestionsAteco = [];
        vm.suggestionsObjAteco = [];
        //Define Selected Suggestion Item
        vm.selectedIndexAteco = -1;
        //Function To Call On ng-change
        vm.searchAteco = function () {
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
            if (vm.record.searchTextAteco == undefined) return;
            if (vm.record.searchTextAteco.length < 5) return; //numero minimo di caratteri

            return datacontext.tAteco_getByText(vm.record.searchTextAteco).then(function (data) {
                //console.log(data);
                if (data) {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = data;
                    data.forEach(function (item) {
                        vm.suggestionsAteco.push(item.Name);
                    });
                }
                if (vm.suggestionsAteco.length == 1) {
                    vm.AssignValueAndHideAteco(0);
                }
            });
        };
        //Keep Track Of Search Text Value During The Selection From The Suggestions List  
        $scope.$watch('selectedIndexAteco', function (val) {
            if (val !== -1 && typeof (val) != 'undefined') {
                vm.record.searchTextAteco = vm.suggestionsAteco[vm.selectedIndexAteco];
                vm.record.TAtecoId = vm.suggestionsObjAteco[vm.selectedIndexAteco].Id;
            }
        });
        //Reset Text of Ateco
        vm.resetTextAteco = function () {
            if (vm.record.TAtecoId > 0) {
                vm.record.TAtecoId = '';
                vm.validAteco = false;
                vm.record.searchTextAteco = '';
            }
        };
        //Text Field Events
        //Function To Call on ng-keydown
        vm.checkKeyDownAteco = function (event) {
            if (event.keyCode === 40) {//down key, increment selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco + 1 !== vm.suggestionsAteco.length) {
                    vm.selectedIndexAteco++;
                }
            } else if (event.keyCode === 38) { //up key, decrement selectedIndexAteco
                event.preventDefault();
                if (vm.selectedIndexAteco - 1 !== -1) {
                    vm.selectedIndexAteco--;
                }
            } else if (event.keyCode === 13) { //enter key, empty suggestions array
                event.preventDefault();
                vm.suggestionsAteco = [];
                vm.suggestionsObjAteco = [];
            }
        };
        //Function To Call on ng-keyup
        vm.checkKeyUpAteco = function (event) {
            if (event.keyCode !== 8 && event.keyCode !== 46) {//delete or backspace     			
                if (vm.record.searchTextAteco == "") {
                    vm.suggestionsAteco = [];
                    vm.suggestionsObjAteco = [];
                }
            } else {
                if (vm.record.TAtecoId > 0) {
                    vm.record.TAtecoId = '';
                    vm.record.searchTextAteco = '';
                }
            }
        };
        //======================================
        //List Item Events
        //Function To Call on ng-click
        vm.AssignValueAndHideAteco = function (index) {
            //console.log('hide');
            vm.record.searchTextAteco = vm.suggestionsAteco[index];
            vm.record.TAtecoId = vm.suggestionsObjAteco[index].Id;
            vm.suggestionsAteco = [];
            vm.suggestionsObjAteco = [];
        };
        //======================================
        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- END -#-#-#-#-#-#

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS LIBERO PROF FOR CF -#-#-#-#-#-#
        vm.existsL_CF = false;
        vm.searchL_CF = function (value) {
            vm.existsL_CF = false;
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri 
            vm.existsL_CF = true;
            return datacontext.cndAccreditamento_exists(vm.record.Id, value, '', '', '', false, vm.record.ProgettoId).then(function (data) {
                vm.existsL_CF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR CF -#-#-#-#-#-#
        vm.existsCF = false;
        vm.searchCF = function (value) {
            vm.existsCF = false;
            if (value == undefined) return;
            if (value.length != 11 && value.length != 16) return; //numero minimo di caratteri  
            vm.existsCF = true;
            return datacontext.cndAccreditamento_exists(vm.record.Id, value, '', '', vm.record.ProgettoId).then(function (data) {
                vm.existsCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-EXISTS AZIENDA FOR PIVA -#-#-#-#-#-#
        vm.existsPIVA = false;
        vm.searchPIVA = function (value) {
            vm.existsPIVA = false;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri  
            vm.existsPIVA = true;
            return datacontext.cndAccreditamento_exists(vm.record.Id, '', value, '', vm.record.ProgettoId).then(function (data) {
                vm.existsPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID PARTITA IVA -#-#-#-#-#-#
        vm.validPIVA = true;
        vm.getValidPIVA = function (value) {
            vm.validPIVA = true;
            if (value == undefined) return;
            if (value.length != 11) return; //numero minimo di caratteri   
            vm.validPIVA = false;
            return datacontext.validazione_piva(value, false).then(function (data) {
                return vm.validPIVA = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID CODICE FISCALE -#-#-#-#-#-#
        vm.validCF = true;
        vm.getValidCF = function (value) {
            vm.validCF = true;
            if (value == undefined) return;
            if (value.length != 16) return; //numero minimo di caratteri   
            vm.validCF = false;
            return datacontext.validazione_cf(value).then(function (data) {
                return vm.validCF = data;
            });
        };

        //#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#-#- VALID FIELDS CODICE FISCALE -#-#-#-#-#-#
        vm.validFieldsCF = true;
        vm.getValidFieldsCF = function () {
            vm.validFieldsCF = vm.record.L_CodiceFiscale != undefined && vm.record.L_CodiceFiscale.length > 10 ? false : true;
            if (vm.record.L_CodiceFiscale == undefined) return;
            if (vm.record.L_CodiceFiscale.length != 16) return; //numero minimo di caratteri
            if (vm.record.L_Nome == undefined) return;
            if (vm.record.L_Cognome == undefined) return;
            if (vm.record.L_Sesso == undefined) return;
            if (vm.record.L_PaeseNascId == 0 && (vm.record.L_ComuneNascId == undefined || vm.record.L_ComuneNascId == 0)) return;
            if (vm.record.L_DtNasc == undefined || vm.record.L_DtNasc == '') return;
            var strDtNasc = common.dateToString(vm.record.L_DtNasc); //la data deve avere formato dd/MM/yyyy            
            return datacontext.validazione_fieldsCF(vm.record.L_CodiceFiscale, vm.record.L_Nome, vm.record.L_Cognome, vm.record.L_Sesso, strDtNasc, vm.record.L_PaeseNascId, vm.record.L_ComuneNascId).then(function (data) {
                return vm.validFieldsCF = data;
            });
        };

        // #endregion

    }
})();
